import type { ReactNode } from 'react';

const MARK_CLASS =
  'rounded-[3px] bg-[color-mix(in_oklab,var(--chart-4)_32%,transparent)] px-px text-inherit';

/** Highlight case-insensitive occurrences of `query` inside `text`. */
export function highlightQuery(text: string, query: string): ReactNode {
  const q = query.trim();
  if (!q || !text) return text;

  const lowerText = text.toLowerCase();
  const lowerQuery = q.toLowerCase();
  const parts: ReactNode[] = [];
  let cursor = 0;
  let matchIndex = lowerText.indexOf(lowerQuery, cursor);
  let key = 0;

  while (matchIndex >= 0) {
    if (matchIndex > cursor) {
      parts.push(text.slice(cursor, matchIndex));
    }
    parts.push(
      <mark key={key} className={MARK_CLASS}>
        {text.slice(matchIndex, matchIndex + q.length)}
      </mark>,
    );
    key += 1;
    cursor = matchIndex + q.length;
    matchIndex = lowerText.indexOf(lowerQuery, cursor);
  }

  if (cursor < text.length) {
    parts.push(text.slice(cursor));
  }

  return parts.length > 0 ? parts : text;
}
